import { apiAuthCaller } from '@services/apiCaller';
import { IRootStore } from '@stores/index';
import { action, observable } from 'mobx';
import { IRudderStackLibraryStore, RudderStackLibraryStore } from '@stores/rudderstackLibrary';

export interface IRudderStackLibrariesListStore {
  libraries: IRudderStackLibraryStore[];
  getLibraries(): void;
  getById(libraryId: string): IRudderStackLibraryStore | undefined;
}

export class RudderStackLibrariesListStore implements IRudderStackLibrariesListStore {
  @observable public libraries: IRudderStackLibraryStore[] = [];

  @observable public rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
  }

  @action.bound
  public async getLibraries() {
    try {
      const { token } = this.rootStore.userStore;
      const res = await apiAuthCaller(token).get('/transformationRudderStackLibraries');
      this.libraries = res.data.libraries.map(
        (library: IRudderStackLibraryStore) => new RudderStackLibraryStore(library),
      );
    } catch (err) {}
  }

  @action.bound
  public getById(libraryId: string): IRudderStackLibraryStore | undefined {
    return this.libraries.find((t) => t.id === libraryId);
  }
}
